import React, { useState } from 'react'
import { Drawer, Checkbox, DatePicker } from 'antd'
import { useHistory, useParams } from 'react-router-dom'
import pluralize from 'pluralize'
import Select from 'react-select'
import Creatable from 'react-select/creatable'
import moment from 'moment'

import { useToggle, useListData } from '../../modules'
import NewInventoryItem from './newInventoryItem'
import SelectLabel from '../reusable/selectLabel'

const InvoiceItem = ({ onClose, onSave, record }) => {
    const [bulk, setBulk] = useState(record?.bulk ?? 1)
    const [contains, setContains] = useState(record?.contains ?? 0)
    const [bp, setBp] = useState(record?.bp ?? 1)
    const [discount, setDiscount] = useState(record?.discount ?? 0)
    const [vat, setVat] = useState(record?.vat ?? 0)
    const [string, setString] = useState('')
    const [inv, setInv] = useState(record?.item)
    const [batch, setBatch] = useState(record?.batch)
    const [account, setAccount] = useState(record?.account ? { label: record?.account?.name, value: record?.account?._id } : null)
    const [expiry, setExpiry] = useState(record?.expiry ? moment(record?.expiry) : undefined)
    const [name, setName] = useState(record?.name)
    const [accounts, setAccounts] = useState([])
    const [issuedIn, setIssuedIn] = useState(record?.issuedIn)
    const [receivedIn, setReceivedIn] = useState(record?.receivedIn)
    
    const [singles, toggleSingles, setSingles] = useToggle(record?.issuedIn === record?.receivedIn)
    const [perc, togglePerc] = useToggle()
    const [priceBulk, togglePriceBulk, setPriceBulk] = useToggle(record?.issuedIn !== record?.receivedIn)
    const [visible, toggleVisible] = useToggle(true)
    const [newItem, toggleNewItem] = useToggle()
    const [inventory, toggleInventory] = useToggle()

    const history = useHistory()
    const { index } = useParams()

    const [
        { loading: invLoading, fetch: fetchInvItems },
        { list: items = [] }
    ] = useListData('inventoryItems', { string }, { notify: true }, 'items')
    
    const [
        { loading, error }, 
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('accounts', { string, types:['Other Current Assets', 'Fixed Assets', 'Other Current Liabilities', 'Expenses', 'Cost of Goods Sold', 'Stock'] }, { notify: true, manual: false }, 'accounts', 100, ({ accounts: data }) => {
        let obj = {}
        
        data.forEach(acc => {
            if (!obj[acc.type])
                obj[acc.type] = []

            obj[acc.type].push({
                label: acc.name,
                value: acc._id
            })
        })

        let final = []
        for (let typ in obj) {
            final.push({
                label: typ,
                options: obj[typ]
            })
        }

        setAccounts(final)
    })

    const search = str => {
        if (str?.trim()?.length > 2) {
            setString(str)
            fetchInvItems()
        }
    }

    const close = () => {
        toggleVisible()
        // onClose()
        setTimeout(() => history.goBack(), 300)
    }

    const toggleInv = () => {
        if (inventory) {
            setReceivedIn('Units')
            setIssuedIn('Units')
        }
        
        setInv()
        setName()
        setPriceBulk(false)
        toggleInventory()
    }

    const selectItm = itmm => {
        let sng = itmm.issuedIn === itmm.receivedIn
        setIssuedIn(itmm.issuedIn)
        setReceivedIn(itmm.receivedIn)
        setInv(itmm)
        setName(itmm.name)
        setSingles(sng)
        setPriceBulk(!sng)
        setAccount({ label: itmm.account.name, value: itmm.account._id, ...itmm.account })
    }

    const modify = e => {
        switch (e.target.name) {
            case 'bulk':
                setBulk(e.target.value)
                break

            case 'contains':
                setContains(e.target.value)
                break

            case 'name':
                setName(e.target.value)
                break

            case 'bp':
                setBp(e.target.value)
                break

            case 'discount':
                setDiscount(e.target.value)
                break

            case 'vat':
                setVat(e.target.value)
                break

            case 'batch':
                setBatch(e.target.value)
                break

            default:
                break
        }
    }

    const save = () => {
        onSave({ 
            name,
            issuedIn,
            receivedIn,
            item: inv,
            bulk, 
            account,
            contains, 
            singles,
            bp: priceBulk ? (bp / contains) : bp, 
            discount: priceBulk ? (perc ? bp * (discount/100) : discount) / contains : (perc ? bp * (discount/100) : discount), 
            vat, 
            batch, 
            expiry 
        }, index)
        close()
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button onClick={save} className="text-white mr-2 hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
                </div>
            }
            width="30%">
            <p className="font-extrabold text-3xl mb-0">{record ? 'Edit' : 'Add'} Item</p>
            {
                newItem &&
                <NewInventoryItem
                    string={string}
                    onPerform={() => search(string)}
                    toggle={toggleNewItem}
                    visible={newItem} />
            }
            <div className="flex flex-wrap mt-3">
                <Checkbox checked={ inventory } onChange={ toggleInv }>Inventory Item</Checkbox>
                <div className="w-full px-3 mb-1">
                    {
                        inventory ?
                            <>
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-username">
                                    Select Inventory Item
                                </label>
                                <Creatable
                                    className="mb-3"
                                    onCreateOption={toggleNewItem}
                                    isLoading={invLoading}
                                    loadingMessage={str => `Searching for "${str?.inputValue}"`}
                                    onInputChange={search}
                                    value={inv}
                                    onChange={selectItm}
                                    options={items.map(itm => ({ label: itm.name, value: itm._id, ...itm }))}
                                    placeholder="Search for inventory item" />
                            </>
                        :
                            <>
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Item Name
                                </label>
                                <input
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                    id="grid-name"
                                    name="name"
                                    value={ name }
                                    onChange={ modify }
                                    type="text"
                                    placeholder="Item Name" />
                            </>
                    }
                </div>
                <div className="w-full px-3 mb-1">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-username">
                        Purchase Account{ inv ? ' (set on the inventory item)' : '' }
                    </label>
                    <Select
                        className="mb-3"
                        isDisabled={ !!inv }
                        value={account}
                        onChange={setAccount}
                        formatGroupLabel={ SelectLabel }
                        options={accounts}
                        placeholder="Select account" />
                </div>
                {
                    issuedIn !== receivedIn &&
                    <Checkbox checked={singles} onChange={() => {
                        setBulk(1)
                        toggleSingles()
                        setPriceBulk(false)
                    }}>Items arrived in {issuedIn?.toLowerCase()}</Checkbox>
                }
                {
                    !singles &&
                    <div className="w-full px-3 mb-1">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            How many {receivedIn}?
                        </label>
                        <input
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            id="grid-bulk"
                            name="bulk"
                            value={bulk}
                            onChange={modify}
                            type="number"
                            placeholder="50" />
                    </div>
                }
                <div className="w-full px-3 mb-1">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        How many {issuedIn}?
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-contains"
                        type="number"
                        name="contains"
                        value={contains}
                        onChange={modify}
                        placeholder="100" />
                    <p className="text-gray-500 text-xs italic">How many {issuedIn?.toLowerCase()} {singles ? 'were received' : `does each ${receivedIn && pluralize.singular(receivedIn?.toLowerCase())} contain`}?</p>
                </div>
                <div className="w-full px-3 mb-1">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Batch Number
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-batch"
                        type="text"
                        name="batch"
                        value={batch}
                        onChange={modify}
                        placeholder="Batch No." />
                </div>
                <div className="w-full px-3 pb-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Expiry Date
                    </label>
                    <DatePicker
                        value={expiry}
                        onChange={setExpiry}
                        dateFormat="MM/DD/YYYY" />
                </div>
                {
                    !singles &&
                    <Checkbox checked={ priceBulk } onChange={ togglePriceBulk }>Price is given per {pluralize.singular(issuedIn?.toLowerCase())}</Checkbox>
                }
                <div className="w-full my-2 px-3 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Unit Price
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-bp"
                        type="number"
                        name="bp"
                        value={bp}
                        onChange={modify}
                        placeholder="Ksh XXX" />
                </div>
                <Checkbox checked={perc} onChange={ togglePerc }>Discount given as percentage</Checkbox>
                <div className="w-full my-2 px-3 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Discount
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-discount"
                        type="number"
                        name="discount"
                        value={discount}
                        onChange={modify}
                        placeholder="14" />
                    <p className="text-gray-500 text-xs italic">Discount as {perc ? 'percentage %' : 'amount'}</p>
                </div>
                <div className="w-full px-3 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        VAT
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-vat"
                        type="number"
                        name="vat"
                        value={vat}
                        onChange={modify}
                        placeholder="16%" />
                </div>
            </div>
        </Drawer>
    )
}

export default InvoiceItem